import React, { FC, useCallback, useRef, useState } from 'react';

import { Link } from 'react-router-dom';

import { LANDING } from '../../configs/api/api.config';
import { MenuMobile } from '../menu/menu-mobile';
import { IconButton } from '../../shared/ui';

const Header: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
    window.requestAnimationFrame(() => menuButtonRef.current?.focus());
  }, []);

  return (
    <header className="relative z-header h-headerHeightMobile w-full bg-white shadow-raised lg:h-headerHeight">
      <div className="mx-auto h-full w-full px-4 py-2 sm:px-[30px]">
        <div className="flex h-full items-center justify-between gap-3">
          <Link to={LANDING} className="flex min-w-0 shrink items-center gap-2 sm:gap-3">
            <span className="shrink-0 text-display-s leading-none text-danger sm:text-display-m md:text-display-l">
              ZiNGiZi
            </span>
            <span className="hidden flex-col justify-center gap-0.5 leading-tight sm:flex">
              <span className="whitespace-nowrap text-micro font-normal text-ink-muted md:text-micro lg:text-ui">
                УМНЫЙ КАБИНЕТ ПСИХОЛОГА
              </span>
              <span className="whitespace-nowrap text-micro font-normal text-ink-muted md:text-micro lg:text-ui">
                ЭТИЧНО | ТЕХНОЛОГИЧНО | ЧЕЛОВЕЧНО
              </span>
            </span>
          </Link>

          <div className="flex shrink-0 items-center gap-2 lg:hidden">
            <Link
              to="/profile"
              aria-label="Перейти в профиль"
              className="flex h-11 w-11 items-center justify-center text-ink transition-colors hover:text-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              <span className="material-symbols-outlined text-display-m font-normal leading-none" aria-hidden="true">
                account_circle
              </span>
            </Link>
            <IconButton
              ref={menuButtonRef}
              label="Открыть меню"
              size="md"
              aria-expanded={isMenuOpen}
              aria-controls="mobile-navigation"
              onClick={() => setIsMenuOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          </div>
        </div>
      </div>
      <MenuMobile openMenu={isMenuOpen} onCloseMenu={closeMenu} />
    </header>
  );
};

const MenuIcon = () => (
  <span className="flex flex-col gap-[5px]" aria-hidden="true">
    <span className="block h-[2px] w-6 rounded-full bg-current" />
    <span className="block h-[2px] w-6 rounded-full bg-current" />
    <span className="block h-[2px] w-6 rounded-full bg-current" />
  </span>
);

export default Header;
